import { render, staticRenderFns } from "./KpiBox.vue?vue&type=template&id=152eb7bf&scoped=true"
import script from "./KpiBox.vue?vue&type=script&lang=js"
export * from "./KpiBox.vue?vue&type=script&lang=js"
import style0 from "./KpiBox.vue?vue&type=style&index=0&id=152eb7bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152eb7bf",
  null
  
)

export default component.exports